var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { useFeatureFlags } from "../../hooks/tenant/useFeatureFlags";
var FeatureFlagContext = createContext(undefined);
export var FeatureFlagProvider = function (_a) {
    var children = _a.children;
    var featureFlags = useFeatureFlags();
    return (_jsx(FeatureFlagContext.Provider, __assign({ value: featureFlags }, { children: children })));
};
export var useFeatureFlagContext = function (feature) {
    var _a;
    var context = useContext(FeatureFlagContext);
    if (!context) {
        throw new Error('useFeatureFlagContext must be used within a FeatureFlagProvider');
    }
    if (feature === undefined)
        return context;
    return (_a = context[feature]) !== null && _a !== void 0 ? _a : false;
};
